import Icon from '@components/common/Icon';
import {TruncateText} from '@ultradent/components';
import invoke from 'lodash.invoke';

const ReviewComment = ( props, context ) => {
    const user = context.user || {};
    const isReviewModerator = user.isReviewModerator || false;
    const {id, response} = props;
    const responseTrimmed = response?.trim();

    return (
        <div>
            {responseTrimmed &&
                <div className="flex my-4 md:ml-8 items-center">
                <span className="flex-0">
                    <Icon.logo name="upi-logo-short" className="text-3xl text-brand"/>
                </span>
                <p data-testid="ultra-response"
                   className={`chat-bubble ml-4 max-w-xs md:max-w-sm lg:max-w-md text-base whitespace-pre-wrap break-words`}>
                    <strong>{upi.i18n.getTextFromKey( 'lbl-ultradentResponded' )}</strong>
                    {' '} - {' '}
                    <TruncateText className="inline" maxCharacters={360}>
                        {responseTrimmed}
                    </TruncateText>
                    <div>
                        {isReviewModerator &&
                            <div className="mt-4">
                            <span onClick={() => invoke( props, 'onRespondReview', id, responseTrimmed )}
                                  data-sx-comment-action="edit"
                                  className="inline-flex link-2 my-1 md:my-0 mr-4">
                                Edit
                            </span>
                            <span onClick={() => invoke( props, 'onDeleteComment', id )}
                                  data-sx-comment-action="delete"
                                  className="inline-flex link-2 my-1 md:my-0 mr-4">
                                Delete Response
                            </span>
                        </div>
                        }
                    </div>
                </p>
            </div>
            }
            {(isReviewModerator && !responseTrimmed) ?
                <div className="mt-4">
                    <span onClick={() => invoke( props, 'onRespondReview', id, response )}
                          data-sx-comment-action="add"
                          data-testid="comment-add"
                          className="inline-flex items-center link-2 my-1 md:my-0 md:mr-4">
                        <Icon.ui center name="comment-bubble-write" className="mr-2 text-xl"/>
                        Respond to customer
                    </span>
                </div>
                : null
            }
        </div>
    );
};

export default ReviewComment;
